import { useEffect, useRef } from "react";
import { Bold, Heading3, Italic, List, Pilcrow, Quote, SquareDashed, Rows3 } from "lucide-react";

const TOOLS = [
  { icon: Bold, title: "Bold", run: () => document.execCommand("bold") },
  { icon: Italic, title: "Italic", run: () => document.execCommand("italic") },
  { icon: Heading3, title: "Sub-heading", run: () => document.execCommand("formatBlock", false, "h3") },
  { icon: Pilcrow, title: "Paragraph", run: () => document.execCommand("formatBlock", false, "p") },
  { icon: List, title: "Bullet list", run: () => document.execCommand("insertUnorderedList") },
  { icon: Quote, title: "Pull quote", run: () => document.execCommand("formatBlock", false, "blockquote") },
  {
    icon: SquareDashed,
    title: "Callout box",
    run: () => document.execCommand("insertHTML", false, '<div class="callout"><span class="callout-label">A NOTE</span><p>Write here…</p></div><p></p>'),
  },
  { icon: Rows3, title: "Writing lines", run: () => document.execCommand("insertHTML", false, '<div class="lines"></div><p></p>') },
];

export const RichEditor = ({ value, onChange, testId }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) ref.current.innerHTML = value || "";
  }, [value]);

  const emit = () => {
    ref.current.querySelectorAll("blockquote").forEach((b) => b.classList.add("pullquote"));
    onChange(ref.current.innerHTML);
  };

  return (
    <div className="border border-[#2A2325]/12 bg-white">
      <div className="flex flex-wrap gap-0.5 border-b border-[#2A2325]/10 p-1 bg-[#FAF7F0]">
        {TOOLS.map(({ icon: Icon, title, run }) => (
          <button
            key={title}
            type="button"
            title={title}
            onMouseDown={(e) => {
              e.preventDefault();
              ref.current.focus();
              run();
              emit();
            }}
            className="p-1.5 text-[#5C5255] hover:text-[#5E2B38] hover:bg-[#F5EFE6] transition-colors"
            data-testid={`${testId}-tool-${title.toLowerCase().replace(/\s/g, "-")}`}
          >
            <Icon size={15} strokeWidth={1.6} />
          </button>
        ))}
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={emit} className="rich-editor p-4" data-testid={testId} />
    </div>
  );
};
